export default __webpack_public_path__ + "static/media/lowerEcllipse.bd18efd0.png";